<template>
  <div><PageTable /></div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'production-reworkreport',
  components: { PageTable },
}
</script>
